import React from 'react';
import ReactDOM from 'react-dom/client';
import './Styles/index.css';
import App from './App.jsx';
import { UserProvider } from "./Contexts/UserContext";
import { LoadingProvider } from "./Contexts/LoadingContext";
//import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <UserProvider>
        <LoadingProvider>
            <App />
        </LoadingProvider>
    </UserProvider>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
